import { ConsignmentStockInRequestListPage } from "@/features/consignment-stockin-request/pages/ConsignmentStockInRequestListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/consignment-stockin-request/")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["consignment_stock_in.request_view"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: ConsignmentStockInRequestListPage,
});
